import { render, staticRenderFns } from "./SettingHomePageNew.vue?vue&type=template&id=311502a2&scoped=true&"
import script from "./SettingHomePageNew.vue?vue&type=script&lang=js&"
export * from "./SettingHomePageNew.vue?vue&type=script&lang=js&"
import style0 from "./SettingHomePageNew.vue?vue&type=style&index=0&id=311502a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311502a2",
  null
  
)

export default component.exports